const LargePinkErrorIcon = () => {
  return (
    <div className="w-[80px] h-[80px] flex items-center justify-center rounded-full bg-primary mx-auto mt-6 mb-6">
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fill-rule="evenodd">
          <circle fill="#FFF" cx="40" cy="40" r="35" />
          <path
            d="M40 80c22.083 0 40-17.917 40-40S62.083 0 40 0 0 17.917 0 40s17.917 40 40 40zm4.792-31.667h-9.636c-.99 0-1.77-.573-1.77-1.302L32.5 14.688c0-.365.156-.73.52-.938.313-.26.782-.417 1.25-.417h11.46c.468 0 .937.157 1.25.417.364.208.52.573.52.938l-.938 32.343c-.052.73-.833 1.302-1.77 1.302zm.26 18.334h-10a1.734 1.734 0 0 1-1.719-1.72v-9.895c0-.937.782-1.719 1.72-1.719h10c.885 0 1.614.782 1.614 1.72v9.895c0 .937-.73 1.719-1.615 1.719z"
            fill="#FF0085"
            fill-rule="nonzero"
          />
        </g>
      </svg>
    </div>
  );
};

export default LargePinkErrorIcon;
